// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import userCheck01Icon from "@/assets/icons/user-check-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type UserCheck01IconProps = Omit<IconProps, "name">;

export function UserCheck01Icon(props: UserCheck01IconProps): React.ReactNode {
  return <Icon name={userCheck01Icon} {...props} />;
}
